/**
 * A pretend logged-in session for the mock server.
 *
 * The console decides who you are from the `user_token` cookie alone - the token is parsed in the browser
 * and the account reducer reads it while the store module is still being evaluated. So this has to run
 * before anything imports the store, which is why `src/index.js` imports it first of all.
 *
 * Only active with REACT_APP_ENABLE_MSW=true, and never in a production build.
 */
import Cookies from 'js-cookie';

const MOCK_USER = {
  sub: 'han.zhou',
  name: 'HAN ZHOU',
  email: 'han.zhou@example.com',
  privilegedAccount: false
};

const base64url = value =>
  window
    .btoa(value)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** Not signed - nothing verifies it locally, and the mock server never looks at it. */
const fakeToken = () => {
  const header = base64url(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = base64url(
    JSON.stringify({
      ...MOCK_USER,
      exp: Math.floor(Date.now() / 1000) + 24 * 60 * 60
    })
  );
  return `${header}.${payload}.mock`;
};

if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ENABLE_MSW === 'true'
) {
  // No domain option: on localhost a main-domain cookie is not written back.
  Cookies.set('user_token', fakeToken(), { expires: 1 });
  Cookies.set('is_login', 'true', { expires: 1 });
  Cookies.set('wiw_name', MOCK_USER.name, { expires: 1 });
}

export default MOCK_USER;
